<template>
    <UPSWorldShip></UPSWorldShip>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const UPSWorldShip = defineAsyncComponent(() =>
    import("../../components/Logistics/UPSWorldShip.vue")
);
export default {
    name: "Logistics_UPS_WorldShip",
    components: { UPSWorldShip, AuthLayout },
};
</script>
